import { useMemo, useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

export default function useAssignmentsList({ assignments = [] }) {
  const intl = useIntl();
  const [sectionsState, setSectionsState] = useState({});

  const sentAssignments = useMemo(() => assignments.filter((a) => a.sent), [assignments]);

  const noSentAssignments = useMemo(() => assignments.filter((a) => !a.sent), [assignments]);

  const sections = useMemo(() => {
    const result = [];

    if (noSentAssignments.length > 0) {
      result.push({
        id: 'no-sent',
        title: intl.formatMessage({ id: 'assignment.noSent' }),
        assignments: noSentAssignments,
      });
    }
    if (sentAssignments.length > 0) {
      result.push({
        id: 'sent',
        title: intl.formatMessage({ id: 'assignment.sent' }),
        assignments: sentAssignments,
      });
    }
    return result;
  }, [sentAssignments, noSentAssignments, intl]);

  const onToggleSection = useCallback((section) => {
    setSectionsState((s) => ({ ...s, [section.id]: !s[section.id] }));
  }, []);

  const isSectionOpen = useCallback((section) => !sectionsState[section.id], [sectionsState]);

  return { sections, isSectionOpen, onToggleSection };
}
